import { defineMessages } from "react-intl";
import { UserStatisticsGameType } from "../../contract/pam.js";
const localizedUserStatisticsGameType = defineMessages({
  [UserStatisticsGameType.Nl]: {
    id: "userStatisticsGameTypeNL",
    defaultMessage: "NL"
  },
  [UserStatisticsGameType.Sd]: {
    id: "userStatisticsGameTypeSD",
    defaultMessage: "SD"
  },
  [UserStatisticsGameType.Plo]: {
    id: "userStatisticsGameTypePLO",
    defaultMessage: "PLO"
  }
});
export {
  localizedUserStatisticsGameType
};
//# sourceMappingURL=userStatisticsGameType.js.map
